import React from 'react'
import { useHistory } from 'react-router-dom'
import { Flex, Text } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import { CloseButton } from 'components/CloseButton'
import ActionButton from 'views/VvsGotchi/components/ActionButton'
import { Path } from 'config/constants/paths'
import historyBackOrReplace from 'utils/historyBackOrReplace'
import styled from 'styled-components'
import { FULL_HEALTH_LUCKY_DRAW_URL } from 'config/constants/vvsgotchi'
import { DarkPageContainer } from '../styles'
import PixelatedImage from '../components/PixelatedImage'

const StyledLeftText = styled(Text)`
  align-self: flex-start;
`

const luckyDrawStarted = new Date('2023-02-07T00:00:00.000Z').getTime()

const Congrats: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()

  return (
    <DarkPageContainer popup>
      <Flex justifyContent="flex-end" m={3}>
        <CloseButton onClick={() => historyBackOrReplace(history, Path.VVS_GOTCHI_TEAM)} />
      </Flex>
      <Flex flexDirection="column" justifyContent="center" alignItems="center" my={3} mx={4} gap="16px">
        <PixelatedImage src="/images/vvsGotchi/mysteryBox.png" width="32px" />
        <Text fontSize="20px" fontWeight="600" color="white">
          {t('Congrats! You hit 100 health points!')}
        </Text>
        <Text textAlign="left" color="white">
          {t('You will be added to our lucky draw if you have fulfilled the following criteria:')}
        </Text>
        <Text textAlign="left" color="white">
          {t('1. Your team’s health meter is at 100 at 9am UTC')}
          <br />
          {t('2. You have not previously won a lucky draw')}
        </Text>
        <Text textAlign="left" color="white">
          {t('The lucky draw will be held and winner will be announced on Discord')}
        </Text>
        {Date.now() < luckyDrawStarted && (
          <StyledLeftText color="white">{t('Note: Lucky draw will start on Feb 6 2023')}</StyledLeftText>
        )}
      </Flex>
      <ActionButton m={3} onClick={() => window.open(FULL_HEALTH_LUCKY_DRAW_URL, '_blank', 'noreferrer')}>
        {t('Go to Discord')}
      </ActionButton>
    </DarkPageContainer>
  )
}

export default Congrats
